var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPsycheLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "154.76mm",
    height: "34.983mm",
    viewBox: "0 0 154.76 34.983",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.835 -86.504)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.36581,
    "aria-label": "PHYCHE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.891 30.809q0 0.71448-0.25007 1.4004-0.25007 0.67875-0.71448 1.1432-0.63588 0.62874-1.4218 0.95026-0.77878 0.32152-1.9434 0.32152h-1.7076v3.4652h-2.7436v-10.639h4.5155q1.0146 0 1.7076 0.17862 0.70019 0.17148 1.236 0.52157 0.64303 0.42154 0.97884 1.0789 0.34295 0.65732 0.34295 1.579zm-2.8365 0.0643q0-0.45012-0.24292-0.77164-0.24292-0.32866-0.56444-0.45726-0.42869-0.17148-0.83594-0.18576-0.40725-0.02143-1.086-0.02143h-0.47156v3.1866h0.78592q0.70019 0 1.1503-0.08574 0.45726-0.08574 0.76449-0.34295 0.26436-0.22863 0.37867-0.543 0.12146-0.32152 0.12146-0.77878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.76 27.451-3.9225 6.5232v4.1154h-2.7436v-3.9868l-3.9868-6.6518h3.1151l2.3006 4.1154 2.222-4.1154z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.65 38.296q-1.186 0-2.1934-0.35009-1.0003-0.35009-1.7219-1.0431-0.72162-0.69304-1.1217-1.729-0.39296-1.036-0.39296-2.3935 0-1.2646 0.37867-2.2935 0.37868-1.0288 1.1003-1.7648 0.69304-0.70733 1.7147-1.0932 1.0288-0.38582 2.2435-0.38582 0.67161 0 1.2075 0.07859 0.543 0.07145 1.0003 0.19291 0.4787 0.13575 0.86452 0.30722 0.39296 0.16433 0.68589 0.30723v2.5793h-0.31437q-0.20005-0.17147-0.50727-0.40725-0.30009-0.23578-0.6859-0.46441-0.39297-0.22863-0.85023-0.38582-0.45727-0.15718-0.97884-0.15718-0.57872 0-1.1003 0.18576-0.52157 0.17862-0.96455 0.60016-0.42154 0.40725-0.68589 1.0789-0.25722 0.67161-0.25722 1.629 0 1.0003 0.27865 1.6719 0.28579 0.67161 0.71448 1.0574 0.43583 0.39296 0.97169 0.56444 0.53586 0.16433 1.0574 0.16433 0.50014 0 0.98598-0.15004 0.49299-0.15004 0.90739-0.40725 0.35009-0.2072 0.65017-0.44298 0.30008-0.23578 0.49299-0.40725h0.28579v2.5435q-0.4001 0.17862-0.76449 0.3358-0.36438 0.15718-0.76449 0.2715-0.52157 0.15004-0.97883 0.22863-0.45727 0.07859-1.2575 0.07859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.63 38.089h-2.7436v-4.687h-4.0511v4.687h-2.7436v-10.639h2.7436v3.8939h4.0511v-3.8939h2.7436z",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.7 38.089h-7.6949v-10.639h7.6949v2.0577h-4.9656v1.8362h4.6084v2.0577h-4.6084v2.6293h4.9656z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.8827e-7,
    y: -81.241,
    width: 210.41,
    height: 55.734,
    ry: 0.65628
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0.36581
  }, /*#__PURE__*/React.createElement("path", {
    d: "m73.523 102.03q0 0.71448-0.25007 1.4004-0.25007 0.67875-0.71448 1.1432-0.63588 0.62874-1.4218 0.95026-0.77878 0.32151-1.9434 0.32151h-1.7076v3.4652h-2.7436v-10.639h4.5155q1.0146 0 1.7076 0.17862 0.70019 0.17148 1.236 0.52157 0.64303 0.42154 0.97884 1.0789 0.34295 0.65731 0.34295 1.579zm-2.8365 0.0643q0-0.45012-0.24292-0.77164-0.24292-0.32866-0.56444-0.45726-0.42869-0.17147-0.83594-0.18576-0.40725-0.0214-1.086-0.0214h-0.47156v3.1866h0.78592q0.70019 0 1.1503-0.0857 0.45726-0.0857 0.76449-0.34295 0.26436-0.22863 0.37867-0.543 0.12146-0.32151 0.12146-0.77878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.4 98.676-3.9225 6.5232v4.1154h-2.7436v-3.9868l-3.9868-6.6518h3.1151l2.3006 4.1154 2.222-4.1154z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.28 109.52q-1.186 0-2.1934-0.35009-1.0003-0.3501-1.7219-1.0431-0.72162-0.69305-1.1217-1.729-0.39296-1.036-0.39296-2.3935 0-1.2646 0.37867-2.2935 0.37868-1.0288 1.1003-1.7648 0.69304-0.70733 1.7147-1.0932 1.0288-0.38582 2.2435-0.38582 0.67161 0 1.2075 0.07859 0.543 0.07145 1.0003 0.19291 0.4787 0.13575 0.86452 0.30722 0.39296 0.16433 0.68589 0.30723v2.5793h-0.31437q-0.20005-0.17148-0.50727-0.40725-0.30009-0.23578-0.6859-0.46441-0.39297-0.22864-0.85023-0.38582-0.45727-0.15718-0.97884-0.15718-0.57872 0-1.1003 0.18576-0.52157 0.17862-0.96455 0.60016-0.42154 0.40725-0.68589 1.0789-0.25722 0.67161-0.25722 1.629 0 1.0003 0.27865 1.6719 0.28579 0.67161 0.71448 1.0574 0.43583 0.39296 0.97169 0.56444 0.53586 0.16433 1.0574 0.16433 0.50014 0 0.98598-0.15004 0.49299-0.15004 0.90739-0.40726 0.35009-0.2072 0.65017-0.44297 0.30008-0.23578 0.49299-0.40726h0.28579v2.5435q-0.4001 0.17862-0.76449 0.33581-0.36438 0.15718-0.76449 0.2715-0.52157 0.15004-0.97883 0.22863-0.45727 0.0786-1.2575 0.0786z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m133.26 109.31h-2.7436v-4.687h-4.0511v4.687h-2.7436v-10.639h2.7436v3.8939h4.0511v-3.8939h2.7436z",
    fill: "#f60",
    strokeWidth: 0.36581
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.33 109.31h-7.6949v-10.639h7.6949v2.0577h-4.9656v1.8362h4.6084v2.0577h-4.6084v2.6293h4.9656z",
    fill: "#fff",
    strokeWidth: 0.36581
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -163.6,
    y: 86.504,
    width: 12.722,
    height: 34.983,
    ry: 0.65628,
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -174.96,
    y: 90.805,
    width: 11.361,
    height: 26.38,
    ry: 0.4949,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -183.6,
    y: 94.819,
    width: 8.6346,
    height: 18.353,
    ry: 0.34431,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 48.83,
    y: -121.49,
    width: 12.722,
    height: 34.983,
    ry: 0.65628,
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 37.469,
    y: -117.19,
    width: 11.361,
    height: 26.38,
    ry: 0.4949,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 28.835,
    y: -113.17,
    width: 8.6346,
    height: 18.353,
    ry: 0.34431,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .054097)",
    fill: "#f60",
    strokeWidth: 0.13417,
    "aria-label": "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.638 106.09q0 1.5759-1.3395 2.5645-1.3324 0.98138-3.6246 0.98138-1.3252 0-2.3138-0.22923-0.98138-0.23639-1.841-0.59455v-2.5573h0.30086q0.85244 0.68051 1.9054 1.0458 1.0602 0.36533 2.0344 0.36533 0.25072 0 0.65903-0.043t0.66619-0.14326q0.31519-0.12894 0.51576-0.32235 0.20774-0.19341 0.20774-0.57307 0-0.351-0.30086-0.60172-0.2937-0.25788-0.86676-0.39398-0.60172-0.14327-1.2751-0.26505-0.66619-0.12894-1.2536-0.32235-1.3467-0.43696-1.9413-1.182-0.58739-0.75214-0.58739-1.8625 0-1.49 1.3324-2.4284 1.3395-0.94556 3.4384-0.94556 1.053 0 2.0774 0.20774 1.0315 0.20057 1.7837 0.5086v2.457h-0.2937q-0.6447-0.51576-1.5831-0.8596-0.93123-0.35101-1.9054-0.35101-0.34384 0-0.68768 0.0502-0.33668 0.043-0.65186 0.17192-0.27937 0.10745-0.47994 0.32951-0.20057 0.2149-0.20057 0.49427 0 0.42264 0.32235 0.65186 0.32235 0.22207 1.2178 0.40831 0.58739 0.12178 1.1246 0.23639 0.54441 0.11462 1.1676 0.31519 1.2249 0.40114 1.8052 1.096 0.58739 0.68768 0.58739 1.7908z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.6445 -71.172)",
    fill: "#f60",
    strokeWidth: 0.13417,
    "aria-label": "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.638 106.09q0 1.5759-1.3395 2.5645-1.3324 0.98138-3.6246 0.98138-1.3252 0-2.3138-0.22923-0.98138-0.23639-1.841-0.59455v-2.5573h0.30086q0.85244 0.68051 1.9054 1.0458 1.0602 0.36533 2.0344 0.36533 0.25072 0 0.65903-0.043t0.66619-0.14326q0.31519-0.12894 0.51576-0.32235 0.20774-0.19341 0.20774-0.57307 0-0.351-0.30086-0.60172-0.2937-0.25788-0.86676-0.39398-0.60172-0.14327-1.2751-0.26505-0.66619-0.12894-1.2536-0.32235-1.3467-0.43696-1.9413-1.182-0.58739-0.75214-0.58739-1.8625 0-1.49 1.3324-2.4284 1.3395-0.94556 3.4384-0.94556 1.053 0 2.0774 0.20774 1.0315 0.20057 1.7837 0.5086v2.457h-0.2937q-0.6447-0.51576-1.5831-0.8596-0.93123-0.35101-1.9054-0.35101-0.34384 0-0.68768 0.0502-0.33668 0.043-0.65186 0.17192-0.27937 0.10745-0.47994 0.32951-0.20057 0.2149-0.20057 0.49427 0 0.42264 0.32235 0.65186 0.32235 0.22207 1.2178 0.40831 0.58739 0.12178 1.1246 0.23639 0.54441 0.11462 1.1676 0.31519 1.2249 0.40114 1.8052 1.096 0.58739 0.68768 0.58739 1.7908z"
  }))), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -159.97,
    y: 15.278,
    width: 12.722,
    height: 34.983,
    ry: 0.65628,
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -171.33,
    y: 19.58,
    width: 11.361,
    height: 26.38,
    ry: 0.4949
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    x: -179.97,
    y: 23.593,
    width: 8.6346,
    height: 18.353,
    ry: 0.34431
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 45.197,
    y: -50.262,
    width: 12.722,
    height: 34.983,
    ry: 0.65628,
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 33.837,
    y: -45.96,
    width: 11.361,
    height: 26.38,
    ry: 0.4949
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 25.202,
    y: -41.947,
    width: 8.6346,
    height: 18.353,
    ry: 0.34431
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsycheLogo);
export default __webpack_public_path__ + "static/media/psyche-logo.62018b0ab96c9ec124969def8d290fbf.svg";
export { ForwardRef as ReactComponent };